var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { tabindex: "-1" },
      on: {
        focusout: function ($event) {
          return _vm.closeDropDown($event)
        },
      },
    },
    [
      this.isCreditsInAllSatsEnabled === false
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "credit-badge",
                on: {
                  click: function ($event) {
                    _vm.showDropDown = !_vm.showDropDown
                  },
                },
              },
              [
                _c(
                  "div",
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.totalCost))]),
                    _vm._v(" "),
                    _c("CoinSVG"),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", {
                  class: _vm.showDropDown
                    ? "fa fa-chevron-up"
                    : "fa fa-chevron-down",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDropDown,
                    expression: "showDropDown",
                  },
                ],
                staticClass: "credit-drop-down",
                attrs: { tabindex: "-1" },
              },
              [
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("trans")("Credit Cost"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm._f("trans")("Total Cost")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.totalCost))]),
                      _vm._v(" "),
                      _c("CoinSVG"),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm._f("trans")("Your Balance")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.balance))]),
                      _vm._v(" "),
                      _c("CoinSVG"),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "buy-credits-button",
                    on: { click: _vm.openPaymentModal },
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm._f("trans")("Get more Credits"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fa fa-chevron-right" }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      this.isCreditsInAllSatsEnabled === true && !this.isLegacyUser
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "credit-badge",
                on: {
                  click: function ($event) {
                    _vm.showDropDown = !_vm.showDropDown
                  },
                },
              },
              [
                _c("CoinSVG"),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.creditCalculation.factor))]),
                _vm._v("\n            /\n            "),
                this.creditCalculation.unit === "milliseconds"
                  ? _c("ClockSVG")
                  : _c("PageSVG"),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.costRate))]),
                _vm._v(" "),
                this.creditCalculation.unit === "milliseconds"
                  ? _c("strong", { staticClass: "mr-1" }, [_vm._v("s")])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  class: _vm.showDropDown
                    ? "fa fa-chevron-up"
                    : "fa fa-chevron-down",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDropDown,
                    expression: "showDropDown",
                  },
                ],
                staticClass: "credit-drop-down",
                attrs: { tabindex: "-1" },
              },
              [
                _c("div", [_c("span", [_vm._v(_vm._s(_vm.translatedText))])]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.translatedUnitText))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("strong", [
                        _vm._v(_vm._s(this.creditCalculation.factor)),
                      ]),
                      _vm._v(" "),
                      _c("CoinSVG"),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm._f("trans")("Your Balance")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.balance))]),
                      _vm._v(" "),
                      _c("CoinSVG"),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "buy-credits-button",
                    on: { click: _vm.openPaymentModalCreditAllSatsEnabled },
                  },
                  [
                    _c(
                      "strong",
                      { staticClass: "align-items-center d-flex" },
                      [
                        _c("CoinSVG", { staticClass: "mr-1" }),
                        _vm._v(_vm._s(_vm._f("trans")("Get Credits"))),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "fa fa-arrow-right lh-inherit" }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }